module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "height": "100%",
      "padding": "0"
    },
    attrs: {
      "fill-height": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "fill-height": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('AdminSideBarMenu'), _vm._v(" "), _c('v-flex', {
    staticClass: "dashboard-view"
  }, [_c('v-breadcrumbs', [_c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Admin")]), _vm._v(" "), _c('v-breadcrumbs-item', {
    attrs: {
      "disabled": true
    }
  }, [_vm._v("Resources")])], 1), _vm._v(" "), _c('v-card', {
    staticClass: "bordered-card",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {
    staticClass: "grey--text text-underline text--darken-4"
  }, [_vm._v("\n            Resources\n          ")])], 1), _vm._v(" "), _c('v-card-title', [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goto('/admin/resources/new')
      }
    }
  }, [_c('v-icon', [_vm._v("add")]), _vm._v("\n              Add new\n            ")], 1)], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.resources,
      "rows-per-page-items": [15, 25, 50, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          staticClass: "content-table-row"
        }, [_c('td', [_vm._v(_vm._s(_vm._f("actualDate")(props.item.submitdate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("actualDate")(props.item.revisiondate)))]), _vm._v(" "), _c('td', {
          staticClass: "no-wrap-cell"
        }, [_vm._v("\n                " + _vm._s(props.item.user.firstname) + " " + _vm._s(props.item.user.lastname) + "\n              ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.title))]), _vm._v(" "), _c('td', {
          staticClass: "no-wrap-cell"
        }, [_vm._v(_vm._s(props.item.category))]), _vm._v(" "), _c('td', {
          staticClass: "no-wrap-cell"
        }, [_vm._v(_vm._s(props.item.featured === true ? 'Featured' : 'Not Featured'))]), _vm._v(" "), _c('td', {
          staticClass: "no-wrap-cell"
        }, [(props.item.featured === false) ? _c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "green--text",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.approveSubmission(props.item.id, props.item.submitby)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("done")])], 1), _vm._v(" "), _c('span', [_vm._v("Feature")])], 1) : _c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "red--text",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.rejectSubmission(props.item.id, props.item.submitby)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("clear")])], 1), _vm._v(" "), _c('span', [_vm._v("Remove Featured")])], 1), _vm._v(" "), _c('v-tooltip', {
          attrs: {
            "top": ""
          }
        }, [_c('v-btn', {
          staticClass: "blue--text",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.goto('/admin/resources/new?mode=edit&id=' + props.item.id)
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('span', [_vm._v("Edit")])], 1), _vm._v(" "), _c('v-btn', {
          attrs: {
            "icon": "",
            "medium": ""
          },
          on: {
            "click": function($event) {
              return _vm.assignId(props.item.id, 'emailDialog')
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "medium": ""
          }
        }, [_vm._v("email")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "blue--text",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              return _vm.openViewModal(props.item)
            }
          }
        }, [_c('v-icon', [_vm._v("remove_red_eye")])], 1), _vm._v(" "), _c('v-btn', {
          staticClass: "red--text",
          attrs: {
            "slot": "activator",
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.assignId(props.item.id, 'dialog')
            }
          },
          slot: "activator"
        }, [_c('v-icon', [_vm._v("delete_forever")])], 1)], 1)])]
      }
    }, {
      key: "pageText",
      fn: function(ref) {
        var pageStart = ref.pageStart;
        var pageStop = ref.pageStop;

        return [_vm._v("\n            From " + _vm._s(pageStart) + " to " + _vm._s(pageStop) + "\n          ")]
      }
    }])
  })], 1), _vm._v(" "), _c('PageFooter')], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.emailDialog),
      callback: function($$v) {
        _vm.emailDialog = $$v
      },
      expression: "emailDialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Confim Email")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to notify all users?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.emailDialog = false
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.emailDialog = false;
        _vm.sendMail()
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "lazy": "",
      "absolute": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Really delete?")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Are you sure you want to delete?")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": "flat"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.deleteRow()
      }
    }
  }, [_vm._v("Yes")])], 1)], 1)], 1), _vm._v(" "), _c('resources-modal', {
    staticStyle: {
      "width": "600px"
    },
    attrs: {
      "dialog": _vm.view_dialog,
      "item": _vm.selectedItem
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelViewModal()
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a9f85a1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/settings/ResourcesListView.vue
// module id = 1716
// module chunks = 11